module.exports = __webpack_public_path__ + "static/img/10.638e7f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/10.png
// module id = M+Lo
// module chunks = 1